import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import ReactHtmlParser from 'react-html-parser'
import 'slick-carousel/slick/slick.css'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ContentBlock from 'components/atoms/ContentBlock'
import BigButton from 'components/molecules/BigButton'
import Typography from 'components/atoms/Typography'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import { userCheckMobileScreen } from 'helpers/tools'
import './SetBigButton.scss'

function SetBigButton({ data, acessibilityMode }) {
  const description = get(data, 'description.value')
  const title = get(data, 'title')
  const items = get(data, 'items')
  const themeClasses = get(data, 'theme.entity.classes')
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(userCheckMobileScreen())
  })

  const sliderSettings = {
    dots: true,
    dotsClass: `slick-dots white`,
    infinite: false,
    variableWidth: true,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  }

  return (
    <Container fluid="fluid" className={`set-big-button bg-${themeClasses || 'primary'} pt-2`}>
      <Container className="py-4 py-md-5">
        <Row>
          <Col bgcolor="primary" xs={12}>
            <ContentBlock>
              <Typography variant="h2" cssClass="mb-3 title-semibold-lg">
                {title}
              </Typography>

              {description && (
                <Typography variant="p" component="" color="white" cssClass="bloco-conteudo-text mb-5">
                  {ReactHtmlParser(description)}
                </Typography>
              )}
            </ContentBlock>
          </Col>
        </Row>

        {isMobile && !acessibilityMode ? (
          <Slider {...sliderSettings}>
            {Array.isArray(items) &&
              items
                .filter((i) => i.entity)
                .map((item, index) => (
                  <BigButton
                    key={get(item, 'entity.uuid', index)}
                    theme={get(item, 'entity.theme.entity.classes')}
                    icon={get(item, 'entity.icon.entity.media.entity.fieldMediaFile.entity.url')}
                    title={get(item, 'entity.title')}
                    footer
                    url={get(item, 'entity.link.url.path')}
                  />
                ))}
          </Slider>
        ) : (
          Array.isArray(items) &&
          items
            .filter((i) => i.entity)
            .map((item, index) => (
              <BigButton
                key={get(item, 'entity.uuid', index)}
                theme={get(item, 'entity.theme.entity.classes')}
                icon={get(item, 'entity.icon.entity.media.entity.fieldMediaFile.entity.url')}
                title={get(item, 'entity.title')}
                footer
                url={get(item, 'entity.link.url.path')}
                className="mb-3"
              />
            ))
        )}
      </Container>
    </Container>
  )
}

SetBigButton.propTypes = {
  data: PropTypes.object.isRequired,
  accessibilityMode: PropTypes.bool,
}

export default SetBigButton
